import Check from "@mui/icons-material/Check";
import { Card } from "pepsico-ds";
import PropTypes from "prop-types";
import { getDateWithFormat } from "../../../utils/commons";
import { toCamelCase } from "../../../utils/functions";
import ButtonGroupDynamic from "../../common/ButtonGroupDynamic";
import { partnersCodeGroupActionButtons } from "../partnersCodeGroupActionButton";
import "./partnerCodeGroupCard.scss";

const PartnerCodeGroupCard = ({
  partnerCodeGroupData,
  handleActionButtons,
  currentProgramTimezone,
}) => {
  const hasField = (field) =>
    Object.prototype.hasOwnProperty.call(partnerCodeGroupData || {}, field);

  const renderCountValue = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    return value;
  };

  return (
    <Card
      icon=""
      ellipsis=""
      style={{
        padding: "0px",
        borderRadius: "10px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
      }}
    >
      <div className="partner-code-group-card-container">
        <div className="partner-code-group-details">
          <div className="partner-code-group-status-type">
            <span
              className={`status ${partnerCodeGroupData?.status === "ACTIVE" ? "active" : "inactive"}`}
            >
              {partnerCodeGroupData?.status}
            </span>
            {partnerCodeGroupData?.processingStatus && (
              <span className={`code-upload-status`}>
                {partnerCodeGroupData?.processingStatus}
                {partnerCodeGroupData?.processingStatus === "IMPORTED" && (
                  <Check fontSize="small" />
                )}
              </span>
            )}
          </div>
          <h3 className="partner-code-group-name">{partnerCodeGroupData?.name}</h3>
          <div className="additional-fields-container">
            {hasField("uniqueCodeCount") && (
              <div className="field-pair">
                <span className="field-label">Unique code count</span>
                <span className="field-value">
                  {renderCountValue(partnerCodeGroupData?.uniqueCodeCount)}
                </span>
              </div>
            )}
            {hasField("maxAllocation") && (
              <div className="field-pair">
                <span className="field-label">Max allocation</span>
                <span className="field-value">
                  {renderCountValue(partnerCodeGroupData?.maxAllocation)}
                </span>
              </div>
            )}
            {hasField("allocationCount") && (
              <div className="field-pair">
                <span className="field-label">Allocation count</span>
                <span className="field-value">
                  {renderCountValue(partnerCodeGroupData?.allocationCount)}
                </span>
              </div>
            )}
          </div>

          <div className="partner-code-group-dates">
            <div className="date-item">
              <span className="date-label">Start Date</span>
              <span>
                {getDateWithFormat(
                  partnerCodeGroupData?.startDate,
                  currentProgramTimezone
                )}
              </span>
            </div>
            <div className="date-item">
              <span className="date-label">End Date</span>
              <span>
                {getDateWithFormat(
                  partnerCodeGroupData?.endDate,
                  currentProgramTimezone
                )}
              </span>
            </div>
          </div>
          {partnerCodeGroupData?.codeGroupType && (
            <div className="additional-fields-container">
              <div className="field-pair">
                <span className="field-label">Type</span>
                <span className="field-value">
                  {toCamelCase(partnerCodeGroupData?.codeGroupType)}
                </span>
              </div>
            </div>
          )}
          <div className="button-group-container">
            <ButtonGroupDynamic
              items={partnersCodeGroupActionButtons(
                partnerCodeGroupData?.status,
                handleActionButtons,
                partnerCodeGroupData
              )}
              spacing="1px"
              size="medium"
              variant="control"
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

PartnerCodeGroupCard.propTypes = {
  partnerCodeGroupData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    isImported: PropTypes.bool,
    uniqueCodeCount: PropTypes.number,
    maxAllocation: PropTypes.number,
    allocationCount: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  handleActionButtons: PropTypes.func,
  currentProgramTimezone: PropTypes.string,
};

export default PartnerCodeGroupCard;
